import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { WidthProvider, Responsive } from 'react-grid-layout';

import { createLayoutConfig } from 'utils/metricesHelper';
import { LIST } from 'constants/dashboard';

import ListMetrices from './list';
import NumberMetricComponent from './number';
import ConfigureModal from './ConfigureModal';
import ListConfigModal from './list/ListConfigModal';
import SelectMetricesModal from './SelectMetricsModal';

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const Metric = ({
  isMetricsModalVisible,
  toggleMetricsModal,
  addNewMetric,
  isMetricsConfigVisible,
  toggleMetricsConfig,
  dashboardComponents,
  onMetricsSelected,
  onLayoutChange,
  editComponentId,
  configModalTitle,
  saveMetricConfig,
  activeType,
  toggleRemoveConfigModal,
  isMobileBrowser,
  checkNavigatorState
}) => {

  const addBtnLayout = createLayoutConfig(dashboardComponents, 3, 4, isMobileBrowser);
  const dashboardComponentsList = dashboardComponents.map((component) => {
    const { id, dashboard_config, layout_config } = component;
    const layoutConfig = { ...layout_config, static: isMobileBrowser };

    if (dashboard_config.type && dashboard_config.type === LIST) {
      return (
        <div key={layout_config.i} className="dashboard-block metrics-component" data-grid={layoutConfig}>
          <ListMetrices
            id={id}
            saveMetricConfig={saveMetricConfig}
            toggleRemoveConfigModal={toggleRemoveConfigModal}
            toggleMetricsConfig={toggleMetricsConfig}
          />
        </div>
      );
    }
    return (
      <div key={layout_config.i} className="dashboard-block metrics-component" data-grid={layoutConfig}>
        <NumberMetricComponent
          id={id}
          dashboardConfig={dashboard_config}
          toggleMetricsConfig={toggleMetricsConfig}
        />
      </div>
    );
  });

  return (
    <Fragment>
      <SelectMetricesModal
        onMetricsSelected={onMetricsSelected}
        dashboardComponents={dashboardComponents}
        toggleModal={toggleMetricsModal}
        isVisible={isMetricsModalVisible}
      />
      <ConfigureModal
        configModalTitle={configModalTitle}
        saveMetricConfig={saveMetricConfig}
        addNewMetric={addNewMetric}
        editComponentId={editComponentId}
        toggleModal={toggleMetricsConfig}
        isVisible={activeType !== LIST && isMetricsConfigVisible}
        toggleRemoveConfigModal={toggleRemoveConfigModal}
      />
      <ListConfigModal
        editComponentId={editComponentId}
        toggleModal={toggleMetricsConfig}
        configModalTitle={configModalTitle}
        isVisible={activeType === LIST && isMetricsConfigVisible}
        saveMetricConfig={saveMetricConfig}
        addNewMetric={addNewMetric}
        toggleRemoveConfigModal={toggleRemoveConfigModal}
      />
      <ResponsiveReactGridLayout
        className="layout metrics-container"
        cols={{
          lg: 12,
          md: 10,
          sm: 6,
          xs: 4,
          xxs: 2,
        }}
        rowHeight={30}
        width={1200}
        isResizable={false}
        onDragStop={(layout) => onLayoutChange(layout)}
      >
        {dashboardComponentsList}
        <div
          className="dashboard-block metrics-component"
          key={Date.now().toString()}
          data-grid={addBtnLayout}
          onClick={toggleMetricsModal}
        >
          <FontAwesomeIcon className="add-metric" size="4x" icon="plus" />
        </div>
      </ResponsiveReactGridLayout>
    </Fragment>
  );
};

Metric.propTypes = {
  isMetricsModalVisible: PropTypes.bool.isRequired,
  isMetricsConfigVisible: PropTypes.bool.isRequired,
  toggleMetricsConfig: PropTypes.func.isRequired,
  toggleMetricsModal: PropTypes.func.isRequired,
  addNewMetric: PropTypes.func.isRequired,
  onMetricsSelected: PropTypes.func.isRequired,
  editComponentId: PropTypes.string,
  configModalTitle: PropTypes.string,
  saveMetricConfig: PropTypes.func.isRequired,
  activeType: PropTypes.string,
  dashboardComponents: PropTypes.arrayOf(
    PropTypes.shape({
      layout_config: PropTypes.shape({
        i: PropTypes.string,
        x: PropTypes.number,
        y: PropTypes.number,
        w: PropTypes.number,
        h: PropTypes.number,
        static: PropTypes.bool,
      }),
    })
  ),
  toggleRemoveConfigModal: PropTypes.func,
  onLayoutChange: PropTypes.func,
  isMobileBrowser: PropTypes.bool.isRequired
};

Metric.defaultProps = {
  isMetricsModalVisible: false,
  isMetricsConfigVisible: false,
  toggleMetricsConfig: () => { },
  toggleMetricsModal: () => { },
  addNewMetric: () => { },
  onMetricsSelected: () => { },
  saveMetricConfig: () => { },
};

export default Metric;



// WEBPACK FOOTER //
// ./src/components/dashboard/Metric.js